module.exports = __webpack_public_path__ + "static/media/society.2d7261b8.jpg";